import { render } from "./TheHeader.vue?vue&type=template&id=4fff9a4a&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=4fff9a4a&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/1mal1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fff9a4a"]])

export default __exports__